// extracted by mini-css-extract-plugin
export default {"button":"UpButton_button__iCBcP","flareAnimation":"UpButton_flareAnimation__R2X71"};